import { memo } from 'react';
import Slider from '@dtvgo/slider';
import { ProgressBarClassNames } from './utils.js';
import { useSeekingValue } from './ProgressBarContext.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

/* External */
function SeekingFill(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsx(Slider.FillTemplate, {
    className: ProgressBarClassNames.element('seeking-fill', className),
    value: useSeekingValue()
  });
}
var SeekingFill$1 = /*#__PURE__*/memo(SeekingFill);

export { SeekingFill$1 as default };
//# sourceMappingURL=SeekingFill.js.map
